
<template>
  <form id="formStepPrivate" data-vv-scope="step-private">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input
          inputmode="numeric"
          label="کد ملی"
          v-validate="'digits:10|required'"
          name="nationalCode"
          v-model="draftRequest.draftMerchant.nationalCode"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-private.nationalCode")
        }}</span>
      </div>
      <div class="vx-col w-full mt-2">
        <ul class="centerx">
          <li>
            <p-radio
              v-model="draftRequest.draftMerchant.gender"
              :value="true"
              name="radio1"
              color="dark"
              class="p-round p-jelly p-svg"
            >
              <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20"
              >
                <g>
                  <g>
                    <circle cx="62.259" cy="12.942" r="12.942" />
                    <path
                      d="M89.589,65.152c-3.005-20.494-7.554-29.271-18.724-36.117c-0.216-0.133-0.445-0.227-0.672-0.326    c-1.441-0.961-3.061-1.668-4.712-2.074l-3.224,3.246L59.132,26.6c-0.01,0.002-0.021,0.004-0.032,0.006    c-2.392,0.572-4.717,1.785-6.535,3.488c-9.976,6.711-14.227,15.603-17.079,35.058c-0.402,2.744,1.497,5.297,4.243,5.699    c0.247,0.035,0.492,0.055,0.735,0.055c2.452,0,4.599-1.799,4.965-4.297c1.026-6.998,2.214-12.111,3.583-15.978v15.822    c0,1.353,0.262,2.613,0.723,3.771c-0.036,0.263-0.06,0.525-0.06,0.795l0.004,48.117c0,3.279,2.658,5.937,5.938,5.937    c3.28,0,5.939-2.658,5.938-5.938l-0.003-41.291c0.235,0.01,0.47,0.029,0.707,0.029c0.046,0,0.092-0.006,0.139-0.006l-0.001,41.27    c0,3.279,2.659,5.938,5.937,5.938c0.001,0,0.001,0,0.001,0c3.279,0,5.938-2.658,5.938-5.938l0.002-47.819    c0.777-1.441,1.23-3.072,1.23-4.861V49.148c1.608,4.012,2.979,9.527,4.143,17.461c0.367,2.498,2.513,4.297,4.965,4.297    c0.243,0,0.488-0.02,0.736-0.055C88.094,70.449,89.993,67.896,89.589,65.152z"
                    />
                  </g>
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
              مرد</p-radio
            >
          </li>
          <li>
            <p-radio
              v-model="draftRequest.draftMerchant.gender"
              :value="false"
              name="radio1"
              color="pink"
              class="p-round p-jelly p-svg"
            >
              <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20"
              >
                <g>
                  <g>
                    <path
                      d="M384.977,276.115c-0.33-0.902-33.149-90.694-47.603-132.749c-9.325-27.136-24.962-40.895-46.474-40.895    c-29.934,0-39.899,0-69.8,0c-21.512,0-37.149,13.759-46.474,40.895c-14.452,42.055-47.272,131.848-47.603,132.749    c-3.812,10.425,1.549,21.968,11.975,25.779c10.425,3.812,21.968-1.551,25.779-11.975c0.273-0.748,22.776-62.314,38.824-107.645    c1.435,4.712,4.37,8.758,8.233,11.627l0.048,29.451l-34.573,87.18c-1.885,4.755,0.875,10.067,5.834,11.259    c5.161,1.24,11.996,2.93,19.41,4.782V487.88c0,13.321,10.799,24.12,24.12,24.12c13.321,0,24.12-10.799,24.12-24.12V337.975    c3.464,0.307,6.948,0.305,10.413-0.006V487.88c0,13.321,10.799,24.12,24.12,24.12c13.321,0,24.12-10.799,24.12-24.12V326.551    c7.407-1.852,14.236-3.538,19.398-4.776c4.924-1.18,7.731-6.492,5.84-11.261l-34.567-87.163l0.048-29.451    c3.864-2.868,6.797-6.914,8.233-11.627c16.047,45.331,38.551,106.897,38.824,107.645c3.812,10.426,15.354,15.787,25.779,11.975    C383.428,298.083,388.789,286.54,384.977,276.115z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <circle cx="256" cy="43.898" r="43.898" />
                  </g>
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
              زن</p-radio
            >
          </li>
        </ul>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          :disabled="editForbiden"
          name="firstname"
          label="نام"
          v-model="draftRequest.draftMerchant.firstNameFa"
          class="w-full mt-4"
        />
        <vs-input
          :disabled="editForbiden"
          name="lastname"
          label="نام خانوادگی"
          v-model="draftRequest.draftMerchant.lastNameFa"
          class="w-full mt-4"
        />
        <vs-input
          name="dadname"
          label="نام پدر"
          v-model="draftRequest.draftMerchant.fatherNameFa"
          class="w-full mt-4"
        />
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          :disabled="editForbiden"
          name="firstnameEn"
          label="First Name"
          v-model="draftRequest.draftMerchant.firstNameEn"
          class="w-full mt-4"
          style="direction: ltr"
        />
        <vs-input
          name="lastnameEn"
          :disabled="editForbiden"
          label="Last Name"
          v-model="draftRequest.draftMerchant.lastNameEn"
          class="w-full mt-4"
          style="direction: ltr"
        />
        <vs-input
          name="dadnameEn"
          label="Father Name"
          v-model="draftRequest.draftMerchant.fatherNameEn"
          class="w-full mt-4"
          style="direction: ltr"
        />
      </div>
      <div class="vx-col w-full">
        <vs-input
          inputmode="numeric"
          v-validate="'numeric'"
          label="شماره شناسنامه"
          name="birthCrtfctNumber"
          v-model="draftRequest.draftMerchant.birthCrtfctNumber"
          class="w-full mt-4 ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-private.birthCrtfctNumber")
        }}</span>
      </div>
    </div>
    <div class="vx-col w-full">
      <div class="mt-4" style="font-size: 0.8rem">سریال شناسنامه</div>
    </div>
    <div class="vx-row flex-row-reverse">
      <div class="vx-col md:w-4/12 w-full">
        <v-select
          class="selectExample w-full"
          v-model="birthCrtfctSeriesLetter"
          :options="birthCrtfctSeriesLetterList"
        ></v-select>
      </div>
      <div class="vx-col md:w-3/12 w-full">
        <vs-input
          inputmode="numeric"
          v-validate="{ regex: '^[0-9]{2}$' }"
          placeholder="14"
          name="birthCrtfctSeriesNumber"
          v-model="draftRequest.draftMerchant.birthCrtfctSeriesNumber"
          class="w-full ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-private.birthCrtfctSeriesNumber")
        }}</span>
      </div>
      <div class="vx-col md:w-5/12 w-full">
        <vs-input
          inputmode="numeric"
          v-validate="{ regex: '^[0-9]{6}$' }"
          placeholder="123456"
          name="birthCrtfctSerial"
          v-model="draftRequest.draftMerchant.birthCrtfctSerial"
          class="w-full ltr-input"
        />
        <span class="text-danger text-sm">{{
          errors.first("step-private.birthCrtfctSerial")
        }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4" style="font-size: 0.8rem">تاریخ تولد</div>
        <date-picker
          v-validate="'required'"
          inputClass="py-1 px-5  w-full"
          v-model="birthdate"
        ></date-picker>
        <span class="text-danger text-sm">{{
          errors.first("step-private.birthdate")
        }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          @click="savePesonalData"
          class="my-3"
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-save"
          >ذخیره اطلاعات شخصی</vs-button
        >
      </div>
    </div>
  </form>
</template>
<style>
.pretty input:checked ~ .state.p-dark label:after {
  background-color: black !important;
}
.pretty input:checked ~ .state.p-pink label:after {
  background-color: pink !important;
}
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
</style>
<script>
const dict = {
  custom: {
    nationalCode: {
      required: "کد ملی را وارد کنید",
      digits: "کد ملی صحیح نمی‌باشد",
    },
    birthdate: {
      required: "تاریخ را وارد کنید",
    },
    birthCrtfctNumber: {
      numeric: "فقط عدد وارد کنید",
    },
    birthCrtfctSeriesNumber: {
      regex: "شماره سری باید دو رقم باشد",
    },
    birthCrtfctSerial: {
      regex: "سریال باید شش رقم باشد",
    },
  },
};
import Vue from "vue";
Validator.localize("en", dict);

import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { BirthCrtfctSeriesLetter, CreateEditMode } from "@/enums.js";
export default {
  name: "edit-personal-data",
  props: {
    draftRequest: {
      default: () => {
        return {
          draftMerchant: {},
          pspRequestShopAcceptors: [{ shop: {} }],
        };
      },
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      BirthCrtfctSeriesLetter,
      birthCrtfctSeriesLetter: {},
      birthdate: "",
    };
  },
  computed: {
    birthCrtfctSeriesLetterList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.BirthCrtfctSeriesLetter)) {
        ms.push({ value: key, label: value.text });
      }
      return ms;
    },
    editForbiden() {
      return [13, 5].includes(this.draftRequest.step);
    },
  },
  watch: {
    draftRequest: {
      immediate: true,
      handler: function () {
        this.draftRequest.draftMerchant.gender = Boolean(
          this.draftRequest.draftMerchant.gender
        );
        this.birthCrtfctSeriesLetter = this.birthCrtfctSeriesLetterList.find(
          (x) =>
            x.value == this.draftRequest.draftMerchant.birthCrtfctSeriesLetter
        );
        try {
          this.birthdate = "";
          if (this.draftRequest.draftMerchant.birthDate != undefined)
            this.birthdate = this.$moment(
              this.draftRequest.draftMerchant.birthDate,
              "YYYY/MM/DD"
            ).format("jYYYY/jM/jD");
        } catch {}
      },
    },
  },
  methods: {
    savePesonalData() {
      if (!this.validatePrivateData) return;
      let loading = this.$vs.loading();
      let payload = {
        id: this.draftRequest.id,
        nationalCode: this.draftRequest.draftMerchant.nationalCode,
        gender: this.draftRequest.draftMerchant.gender,
        firstName: this.draftRequest.draftMerchant.firstNameFa,
        lastName: this.draftRequest.draftMerchant.lastNameFa,
        dadname: this.draftRequest.draftMerchant.fatherNameFa,
        firstNameEn: this.draftRequest.draftMerchant.firstNameEn,
        lastNameEn: this.draftRequest.draftMerchant.lastNameEn,
        dadnameEn: this.draftRequest.draftMerchant.fatherNameEn,
        birthCrtfctNumber: this.draftRequest.draftMerchant.birthCrtfctNumber,
        birthCrtfctSeriesNumber: this.draftRequest.draftMerchant
          .birthCrtfctSeriesNumber,
        birthCrtfctSerial: this.draftRequest.draftMerchant.birthCrtfctSerial,
      };

      if (this.birthCrtfctSeriesLetter && this.birthCrtfctSeriesLetter.value)
        payload.birthCrtfctSeriesLetter = this.birthCrtfctSeriesLetter.value;

      if (this.birthdate) {
        payload.birthdate = this.$moment(
          this.birthdate,
          "jYYYY/jMM/jDD"
        ).format();
      }

      this.$http
        .post("/api/services/app/Draft/EditPersonalData", payload)
        .then((response) => {
          if (response.data.result == true) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "اطلاعات شخصی با موفقیت ذخیره شد",
            });
            this.$vs.loading.close();
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    validatePrivateData() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-private").then((result) => {
          if (result) {
          } else {
            reject("correct all values");
          }
        });
      });
    },
  },
  mounted() {},
};
</script>